import { ComponentProps, ReactElement } from 'react';

const TimeInputList = (props: ComponentProps<'ul'>): ReactElement => (
  <div className="TimeInput-Unit">
    <ul {...props} className="TimeInput-List" tabIndex={-1} />
  </div>
);

export default TimeInputList;
